<div class="form-input w-100" [ngClass]="{'prefixed': showPrefixPadding}">
  <input (input)="getInputValue()" type="text" class="form-control {{className}}" [id]="id"
    [attr.data-test]="formCtrlName" [(ngModel)]="value" [placeholder]="placeholder">
  <fa-icon *ngIf="showPrefixIcon" class="prefix" [icon]="icons.marker"></fa-icon>
</div>
<div class="mt-2" *ngIf="showExample||showErrorMsg">
  <ng-container *ngIf="showExample">
    <small class="text-muted" *ngIf="!value">E.g 22 Wenlock Rd, London N1 7GU, United Kingdom</small>
  </ng-container>
  <ng-container *ngIf="showErrorMsg">
    <small class="text-danger" *ngIf="value && error_msg">{{error_msg}}</small>
  </ng-container>
</div>
